import { ColumnState } from 'ag-grid-community';
import { DateRange } from 'react-day-picker';
import { create } from 'zustand';
import { defaultSAL1030_R01Dto, SAL1030_R01Dto } from './Dto_SAL1030_R01';

// 검색 조건 필터 인터페이스
export interface SAL1030_R01Filter {
  compCd: string;                       // 사업장 코드
  dateRange: DateRange | undefined;     // 수주기간
  customCd: string;                     // 거래처 코드
  customNm: string;                     // 거래처명
  empNo: string;                        // 담당자 사번
  empNm: string;                        // 담당자명
}

export interface Store_SAL1030_R01 {
  // ====== 검색 필터 ======
  SAL1030_R01Filter: SAL1030_R01Filter;
  setSAL1030_R01Filter: (filter: Partial<SAL1030_R01Filter>) => void;
  
  // ====== 품목별 수주 현황 리스트 ======
  SAL1030_R01List: SAL1030_R01Dto[];
  setSAL1030_R01List: (list: SAL1030_R01Dto[]) => void;
  
  // ====== 선택된 행 ======
  selectedSAL1030_R01: SAL1030_R01Dto | undefined;
  setSelectedSAL1030_R01: (data: SAL1030_R01Dto | undefined) => void;
  initSelectedSAL1030_R01: () => void;
  
  // ====== 전체 개수 ======
  allCount: number;
  setAllCount: (count: number) => void;
  
  // ====== 컬럼 상태 (그리드) ======
  columnState: ColumnState[] | null;
  setColumnState: (state: ColumnState[] | null) => void;

  scrollTop: number | null;
  setScrollTop: (top: number | null) => void;
  
  // ====== 초기화 ======
  initData: () => void;
}

export const defaultSAL1030_R01Filter: SAL1030_R01Filter = {
  compCd: '',
  dateRange: {
    from: new Date(new Date().getFullYear(), new Date().getMonth(), 1), // 이번 달 1일
    to: new Date()  // 오늘
  },
  customCd: '',
  customNm: '',
  empNo: '',
  empNm: '',
};

export const useSAL1030_R01Store = create<Store_SAL1030_R01>((set) => ({
  // ====== 검색 필터 ======
  SAL1030_R01Filter: defaultSAL1030_R01Filter,
  setSAL1030_R01Filter: (filter: Partial<SAL1030_R01Filter>) => set((state) => ({
    SAL1030_R01Filter: {
      ...state.SAL1030_R01Filter,
      ...filter
    }
  })),
  
  // ====== 품목별 수주 현황 리스트 ======
  SAL1030_R01List: [],
  setSAL1030_R01List: (list: SAL1030_R01Dto[]) => {
    // valueIndex 자동 부여
    const listWithIndex = list.map((item, index) => ({
      ...item,
      valueIndex: index + 1,
    }));
    set({ SAL1030_R01List: listWithIndex });
  },
  
  // ====== 선택된 행 ======
  selectedSAL1030_R01: undefined,
  setSelectedSAL1030_R01: (data: SAL1030_R01Dto | undefined) => set({ selectedSAL1030_R01: data }),
  initSelectedSAL1030_R01: () => set({ selectedSAL1030_R01: undefined }),
  
  // ====== 전체 개수 ======
  allCount: 0,
  setAllCount: (count: number) => set({ allCount: count }),
  
  // ====== 컬럼 상태 (그리드) ======
  columnState: null,
  setColumnState: (state: ColumnState[] | null) => set({ columnState: state }),

  scrollTop: null,
  setScrollTop: (top: number | null) => set({ scrollTop: top }),
  
  // ====== 초기화 ======
  initData: () => set({
    SAL1030_R01Filter: defaultSAL1030_R01Filter,
    SAL1030_R01List: [],
    selectedSAL1030_R01: undefined,
    allCount: 0,
    columnState: null,
    scrollTop: null,
  }),
}));
